module.exports = __webpack_public_path__ + "img/carshina22_25.cff1ecfa.jpg";